<template>
  <div id="ContentICG" class="">
    <b-row>
      <b-col>
        <h2 class="pb-3">International Calling Guide content</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab title="Articles" active>
            <Articles @addItem="addArticle" />
          </b-tab>
          <b-tab title="PhoneCodes" ref="phonecodesTab">
            <PhoneCodes @addItem="addPhoneCode" />
          </b-tab>
          <b-tab title="Add Article" ref="addArticle" title-item-class="ml-auto temporary-tab">
            <ArticleAdd />
          </b-tab>
          <b-tab title="Add Phone Code" ref="addPhoneCode" title-item-class="ml-auto temporary-tab">
            <PhoneCodesAdd />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PhoneCodes from '@/views/icg/PhoneCodes'
import PhoneCodesAdd from '@/views/icg/PhoneCodesAdd'
// import PhoneCodesEdit from '@/views/icg/PhoneCodesEdit'
import Articles from '@/views/icg/Articles'
import ArticleAdd from '@/views/icg/ArticleAdd'
// import ArticleEdit from '@/views/icg/ArticleEdit'
export default {
  name: 'ContentICG',
  components: {
    PhoneCodes,
    PhoneCodesAdd,
    Articles,
    ArticleAdd
  },
  mounted () {
    console.log('route', this.$route)
    if ('tab' in this.$route.params) {
      switch (this.$route.params.tab) {
        case 'phonecodes':
          this.$refs.phonecodesTab.activate()
          break
        default:
          break
      }
    }
  },
  methods: {
    addArticle () {
      this.$refs.addArticle.activate()
    },
    addPhoneCode () {
      this.$refs.addPhoneCode.activate()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/content/ContentICG.vue